import { render, staticRenderFns } from "./CredenciamentoFornecedorTermosCredenciamento.vue?vue&type=template&id=be47c086"
import script from "./CredenciamentoFornecedorTermosCredenciamento.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorTermosCredenciamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports